import ui from '@/store/modules/ui';
import pages from '@/store/modules/pages';
import career from '@/store/modules/career';
import employees from '@/store/modules/employees';
import portfolio from '@/store/modules/portfolio';
import resource from '@/store/modules/resource';
import contactUs from '@/store/modules/contactUs';

export default {
  ui,
  pages,
  career,
  employees,
  portfolio,
  resource,
  contactUs,
};



// WEBPACK FOOTER //
// ./src/store/modules/index.js